<template>
    <ds-multiselect
        v-model="internalValue"
        bind-value-only
        data-qa="sms-phone-type-selector"
        multiple
        :options="options"
        :placeholder="selectboxPlaceholder"
        required
        searchable
        :readonly="readOnly"
        :submitted="submitted"
        @input="handleInput"
    >
        <template #help>
            {{ helpText }}
        </template>
    </ds-multiselect>
</template>

<script>
export default {
    props: {
        showError: Boolean,
        value: {
            type: Array,
            default: () => [],
        },
        readOnly: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            internalValue: [],
            options: [
                { value: 'Mobile', label: '' },
                { value: 'Work', label: '' },
                { value: 'Home', label: '' },
                { value: 'Other', label: '' },
            ],
            selectboxPlaceholder: '',
            selectboxErrorMsg: '',
        };
    },

    created() {
        if (window.keapI18nMap !== undefined) {
            this.selectboxPlaceholder = window.keapI18nMap['funnel.campaign.communications.textmsg.selectbox.placeholder'];
            this.selectboxErrorMsg = window.keapI18nMap['funnel.campaign.communications.textmsg.selectbox.errormsg'];
            this.options[0].label = window.keapI18nMap['funnel.campaign.communications.textmsg.selectbox.mobileoption'];
            this.options[1].label = window.keapI18nMap['funnel.campaign.communications.textmsg.selectbox.workoption'];
            this.options[2].label = window.keapI18nMap['funnel.campaign.communications.textmsg.selectbox.homeoption'];
            this.options[3].label = window.keapI18nMap['funnel.campaign.communications.textmsg.selectbox.otheroption'];
        } else {
            this.selectboxPlaceholder = 'Please select phone type(s) to send to.';
            this.selectboxErrorMsg = 'Phone types are managed on the contact record';
            this.options[0].label = 'Mobile';
            this.options[1].label = 'Work';
            this.options[2].label = 'Home';
            this.options[3].label = 'Other';
        }
    },

    watch: {
        value: {
            handler(value) {
                this.internalValue = value;
            },
            immediate: true,
            deep: true,
        },
    },

    computed: {
        helpText() {
            return this.submitted ? this.selectboxPlaceholder : this.selectboxErrorMsg;
        },

        submitted() {
            return this.showError && this.internalValue.length === 0;
        },
    },

    methods: {
        handleInput(value) {
            this.internalValue = value;
            this.$emit('input', value);
        },
    },
};
</script>
